// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from "vue-axios"
import '@/assets/css/base.css'
import '@/assets/css/swiper.min.css'
import '@/assets/css/iconfont.css'
import '@/assets/css/style.css'
import '@/assets/css/media.css'
import '@/assets/js/toastr.css'
import '@/assets/js/js.js'
import '@/assets/js/toastr.js'
// import '@/common/i18n/i18n.js'
import i18n from "./common/i18n/i18n.js"
import VueEcharts from 'vue-echarts'
Vue.component('v-echart', VueEcharts)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});


//import CustumMessage from "@/components/message/index.js";
//Vue.use(CustumMessage);
router.beforeEach((to, from, next) => {
  if (to.path != "/"
    && to.path != "/loginindex"
    && to.path != "/login"
    && to.path != "/description"
    && to.path != "/probe"
    && to.path != "/site"
    && to.path != "/show"
    && to.path != "/feedback"
    && to.path != "/statistics") {
    const islogin = localStorage.getItem("isLogined");
    if (islogin) {
      next()
    } else {
      toastr.info("该功能仅限高级会员使用，请登录或联系我们", "提示", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-center-center"
      }).show();

      next({ path: '/' });
    }
  } else {
    next();
  }
})
//require('./mock.js')
Vue.use(VueAxios, axios)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js